"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import SaveButtonWithModal from "../SaveButtonWithModel";

const dropdownItems = {
  "VALUE CHAIN": [
    "Maize","Macadamia", "Nuts", "Avocados", "Fruits", "Sugar cane", "Potatoes", "Tomatoes", "Onions", "Meat", "Poultry", "Dairy", "Fish", "Bees", "Timber", "Clothing", "Textile", "Footwear", "Leather", "Construction", "Solar", "Wind", "Tourism", "ICT Services", "Waste Management", "Logistics", "Music", "Film", "Fashion", "Gaming"
  ],
};
const orgItems = [
 "Maize",  "Macadamia", "Nuts", "Avocados", "Fruits", "Sugar cane", "Potatoes", "Tomatoes", "Onions", "Meat", "Poultry", "Dairy", "Fish", "Bees", "Timber", "Clothing", "Textile", "Footwear", "Leather", "Construction", "Solar", "Wind", "Tourism", "ICT Services", "Waste Management", "Logistics", "Music", "Film", "Fashion", "Gaming"
];

const languages = [
  "Breeding", "Free Range", "Layers", "Agroprocessing", "Urban Farming", "Training & Mentoring",
  "Trading-Shop", "Spaza Shops", "Hatchery", "Broilers-Free Range", "Layers- Barn, cage, free",
  "Poultry - Feed Mill", "Homesteading", "Research & Development", "Trading - Hawkers",
  "Live Chicken Selling", "Poultry - Chicken Rearing", "Broilers - Barn Raised",
  "Crop Growing for breed", "Food Gardens", "Seed & Plant resources", "Shisa nyama",
  "Catering & Hospitality", "-"
];

const partialSmallText = {
  "Broilers-Free Range": ["Broilers", "-Free Range"],
  "Live Chicken Selling": ["Live Chicken ", "Selling"],
  "Layers- Barn, cage, free": ["Layers- ", "Barn, cage, free"],
  "Poultry - Feed Mill": ["Poultry - ", "Feed Mill"],
  "Research & Development": ["Research ", "& Development"],
  "Trading - Hawkers": ["Trading - ", "Hawkers"],
  "Poultry - Chicken Rearing": ["Poultry - ", "Chicken Rearing"],
  "Broilers - Barn Raised": ["Broilers - ", "Barn Raised"],
  "Crop Growing for breed": ["Crop ", "Growing for breed"],
  "Seed & Plant resources": ["Seed ", "& Plant resources"],
  "Catering & Hospitality": ["Catering ", "& Hospitality"],
};

const Dropdown = ({ label, items, selectedOption, setSelectedOption }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedCircles, setSelectedCircles] = React.useState({});

  const toggleCircle = (index) => {
    setSelectedCircles((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
    <div className="flex flex-col w-full relative">
      <label className="text-[10px] md:text-[32px] font-bold text-black mb-1 md:mb-2">
        {label}
      </label>

      <div className="flex relative z-20 w-fit">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="w-[90px] md:w-[600px] h-[25px] md:h-[60px] bg-[#03897B] text-white font-semibold flex items-center px-1 md:px-4 rounded-l-[5px]"
        >
          <span className="text-[8px] md:text-[24px]">{selectedOption}</span>
        </button>
        <div
          className="w-[20px] h-[25px] md:h-[60px] md:w-[60px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}x
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-3 h-3 md:w-5 md:h-5"
          />
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute z-10 top-[50px] md:top-[120px] w-[120px] md:w-[640px] bg-white rounded-md border border-gray-300 shadow-lg"
          >
            <li className="flex justify-between items-center px-2 py-1 md:px-4 md:py-2">
              <span className="text-[6px] md:text-[20px] font-semibold">
Value chain
              </span>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                alt="icon"
                className="w-3 h-3 md:w-5 md:h-5"
              />
            </li>

            {items.map((item, index) => (
              <li
                key={index}
                onClick={() => handleOptionClick(item)}
                className="flex justify-between items-center px-2 py-1 md:px-4 md:py-2 hover:bg-gray-100 cursor-pointer"
              >
                <span className="text-[6px] md:text-[18px]">{item}</span>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleCircle(index);
                  }}
                  className={`w-3 h-3 md:w-5 md:h-5 rounded-full ${
                    selectedCircles[index] ? "bg-[#03897B]" : "bg-gray-200"
                  }`}
                />
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

const SectionD = ({
  selectedOption,
  setSelectedOption,
  selectedCategories,
  setSelectedCategories,
  onSave
}) => {
  const keys = Object.keys(dropdownItems);

  const toggleSelect = (lang) => {
    setSelectedCategories((prev) =>
      prev.includes(lang) ? prev.filter((item) => item !== lang) : [...prev, lang]
    );
  };

  return (
    <div className="">
      <div className="flex items-center justify-between">
        <h1 className="text-[12px] md:text-[36px] font-bold text-center mx-auto w-full">
          SECTION E: INDUSTRY INTEREST
        </h1>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746297211/Expand_down_18_nrspje.png"
          alt="icon"
          className="w-4 h-4 md:w-10 md:h-10"
        />
      </div>
      <p className="text-center text-[6px] md:text-[20px] font-light text-black my-2 md:my-4">
        Select relevant categories which apply to you, or what you are interested in
      </p>

      {/* Dropdown */}
      <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-4">
        {keys.map((type, i) => (
          <Dropdown
            key={i}
            label="Value chain"
            items={orgItems}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        ))}
      </div>

      {/* Circle Buttons */}
      <div className="grid grid-cols-3 gap-2 md:grid-cols-3">
        {languages.map((lang, i) => {
          const isActive = selectedCategories.includes(lang);
          const splitText = partialSmallText[lang];

          return (
            <button
              key={i}
              onClick={() => toggleSelect(lang)}
              className={`flex items-center justify-between px-2 md:px-4 rounded-md h-[24px] md:h-[60px] ${
                isActive ? "bg-[#E7EBEB]" : "bg-[#E7EBEB]"
              }`}
            >
              <span className="text-[6px] md:text-[20px] font-medium">
                {splitText ? (
                  <>
                    {splitText[0]}
                    <span className="text-[5px] md:text-[14px]">{splitText[1]}</span>
                  </>
                ) : (
                  lang
                )}
              </span>
              <span
                className={`
                  md:w-12 md:h-12 w-3 h-3 rounded-full
                  ${isActive 
                    ? 'bg-[#03897B] md:border-[7px] border-[3px] border-white'
                    : 'md:border-[7px] border-[3px] border-white bg-transparent'}
                `}
              />
            </button>
          );
        })}
      </div>

      <SaveButtonWithModal/>

    </div>
  );
};

export default SectionD;